<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <!-- Login v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo" v-show="loadingLogo==false">
          <b-img :src="resolveLogo()" alt="Logo" style="width: 55%; margin-bottom: 1.5rem;"/>
        </b-link>
        <div style="height: 2rem;" v-show="loadingLogo==true"></div>
        

        <!-- form -->
        <validation-observer ref="loginForm" #default="{invalid}">
          <b-form class="auth-login-form mt-2" @submit.prevent="login">

            <!-- email -->
            <b-form-group label-for="email" label="Email">
              <validation-provider #default="{ errors }" name="Email" rules="required|email">
                <b-form-input id="email" v-model="userEmail" name="login-email" :state="errors.length > 0 ? false:null"
                              placeholder="lucca@example.com" autofocus/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- password -->
            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="password"> {{ $t('Password') }}</label>

              </div>
              <validation-provider #default="{ errors }" name="Password" rules="required">
                <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid':null">
                  <b-form-input id="password" v-model="password" :type="passwordFieldType" class="form-control-merge"
                                :state="errors.length > 0 ? false:null" name="login-password" placeholder="Password"/>

                  <b-input-group-append is-text>
                    <feather-icon class="cursor-pointer" :icon="passwordToggleIcon" @click="togglePasswordVisibility"/>
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-button variant="primary" type="submit" block :disabled="invalid || loading">
              <b-spinner small v-if="loading"/>
              <span v-else>{{ $t('Sign in') }}</span>
            </b-button>
          </b-form>
        </validation-observer>

        <div class="divider my-2">
          <div class="divider-text">
            {{ $t('or') }}
          </div>
        </div>

        <b-card-text class="text-center mt-2">
          <span> {{ $t('if you prefer, sign in using our') }}</span>
          <b-link :to="{name:'auth-forgot-password'}">
            <span> {{ $t('access token') }}</span>
          </b-link>
        </b-card-text>

      </b-card>
      <!-- /Login v1 -->
    </div>
  </div>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver
} from 'vee-validate'
import {
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BCard,
  BLink,
  BCardTitle,
  BCardText,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
  BImg,
    BSpinner
} from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  required,
  email
} from '@validations'
import {
  togglePasswordVisibility
} from '@core/mixins/ui/forms'

import signalrHub from '@core/signalr/signalrHub.js'

import useJwt from '@/auth/jwt/useJwt'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import customerSettigns from '@core/utils/customerSettigns'

import store from '@/store'

import systemStoreModule from '@core/layouts/components/app-navbar/systemStoreModule'
import safeSpotStoreModule from '@/views/main/safe-spot/safeSpotStoreModule'

import { setSafeSpotPermission } from '@/utils/safeSpotPermission'

import {onUnmounted} from '@vue/composition-api'

export default {
  components: {
    BSpinner,
    BButton,
    BImg,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    VuexyLogo,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      loading: false,
      status: '',
      password: '',
      userEmail: '',
      //sideImg: require('@/assets/images/pages/login-v2.svg'),

      // validation rules
      required,
      email,
      userSettings: null,
      loadingLogo: true

    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    async getSetings() {
      this.loadingLogo = true
      this.userSettings = await customerSettigns()
      this.loadingLogo = false
    },
    resolveLogo() {

      if (!this.userSettings) {

        return require('@/assets/images/logo/LogoExtend.png')
      } else {

        return this.userSettings.logoUrl
      }
    },

    async login() {
      // Primeiro, valida o formulário
      const isFormValid = await this.$refs.loginForm.validate();
      if (!isFormValid) {
        return;
      }

      // Debug: log antes de ativar loading
      this.loading = true;

      try {

        // Faz a requisição de login
        const response = await useJwt.login({
          email: this.userEmail,
          password: this.password,
        });


        // Extrai os dados da resposta
        const { userData } = response.data;

        // Configura os tokens e dados do usuário
        useJwt.setToken(response.data.accessToken);
        useJwt.setRefreshToken(response.data.refreshToken);
        localStorage.setItem('userData', JSON.stringify(userData));
        this.$ability.update(userData.ability);
        this.$i18n.locale = userData.language;

        // Verifica permissão do Safe Spot
        try {
          const safeSpotResponse = await this.$store.dispatch('app-safe-spot/fetchIsSafeSpot');
          const isSafeSpot = safeSpotResponse.data;
          setSafeSpotPermission(isSafeSpot);
        } catch (error) {
          // IMPORTANTE: Se falhar, não sobrescrever - manter valor anterior ou não setar
          // Para evitar sobrescrever com false em caso de erro temporário
        }

        // Login bem-sucedido - exibe toast de sucesso
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: `Bem-vindo ${userData.fullName || userData.username}`,
            icon: 'CoffeeIcon',
            variant: 'success',
            text: `Você fez login com sucesso como ${userData.role}.`,
          },
        });


        // Pequeno delay para garantir que o localStorage seja atualizado
        await new Promise(resolve => setTimeout(resolve, 100));

        // Navega para a página inicial (dentro de try-catch para não afetar o login)
        try {
          await this.$router.replace("/");
        } catch (navError) {
          // Erro de navegação não afeta o login bem-sucedido
        }

      } catch (error) {
        // Exibe toast de erro apenas se não foi tratado pelos interceptors
        if (!error.response || !error.response.headers || !error.response.headers.notifications) {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Falha no Login',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: 'Verifique seu e-mail e senha e tente novamente.',
            },
          });
        }

      } finally {
        // Este bloco SEMPRE executa

        // Usando múltiplas estratégias para garantir que o loading seja removido
        this.loading = false;

        // Força uma atualização no próximo tick do Vue
        this.$nextTick(() => {

          // Se ainda estiver true por algum motivo, força para false
          if (this.loading === true) {
            this.loading = false;
            this.$forceUpdate();
          }
        });
      }
    }
  },
  created() { // mounted
    this.getSetings()
  },
  setup() {
    const SYSTEM_APP_STORE_MODULE_NAME = 'app-system'
    const SAFE_SPOT_STORE_MODULE_NAME = 'app-safe-spot'

    // Register modules
    if (!store.hasModule(SYSTEM_APP_STORE_MODULE_NAME)) store.registerModule(SYSTEM_APP_STORE_MODULE_NAME, systemStoreModule)
    if (!store.hasModule(SAFE_SPOT_STORE_MODULE_NAME)) store.registerModule(SAFE_SPOT_STORE_MODULE_NAME, safeSpotStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(SYSTEM_APP_STORE_MODULE_NAME)) store.unregisterModule(SYSTEM_APP_STORE_MODULE_NAME)
      // NÃO desregistrar app-safe-spot pois ele é usado na aplicação após o login
    })
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
